<template>
	<div>
		<div class="box-list-tracking right-shadow">
			<div class="content-list-tracking">
				<v-col cols="12" class="px-4 pb-0">
					<div class="text-h6">Drivers (5)</div>
				</v-col>
				<v-col cols="12" class="px-4 pb-5">
					<v-text-field class="text-body-2" outlined hide-details label="Cari Driver atau Tujuan" append-icon="mdi-magnify"></v-text-field>
				</v-col>
				<v-divider></v-divider>
				<div class="list-tracking">
					<div v-for="i in 5" :key="i" class="cursor-pointer" @click="showDetailExpedition">
						<div class="px-4 pb-2">
							<v-row>
								<v-col cols="3">
									<v-img eager class="rounded-lg" src="/assets/user/profile-pict-menolak-big.png"></v-img>
								</v-col>
								<v-col cols="9">
									<div class="font-size-11">M.Isa Idris (Driver)</div>
									<div class="font-size-10 grey--text text--darken-1">Rio (Support)</div>
									<div class="font-size-10 grey--text text--darken-1">22 Desember 2020</div>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" class="pt-1 pb-1">
									<v-row>
										<v-col cols="5" class="font-size-10 pt-0 pb-1 pr-0">Nomor BAE</v-col>
										<v-col cols="7" class="font-size-10 pt-0 pb-1 pl-0 d-flex">
											<div>:</div>
											<div class="font-weight-bold pl-2">0002</div>
										</v-col>
										<v-col cols="5" class="font-size-10 pt-0 pb-1 pr-0">Tipe Kendaraan</v-col>
										<v-col cols="7" class="font-size-10 pt-0 pb-1 pl-0 d-flex">
											<div>:</div>
											<div class="font-weight-bold pl-2">Box CDD (Double)</div>
										</v-col>
										<v-col cols="5" class="font-size-10 pt-0 pb-1 pr-0">Plat</v-col>
										<v-col cols="7" class="font-size-10 pt-0 pb-1 pl-0 d-flex">
											<div>:</div>
											<div class="font-weight-bold pl-2">AB 001 ML</div>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-slider readonly v-model="taskDriver" min="0" max="5" hide-details color="primary lighten-1">
								<template v-slot:append>
									<v-chip color="deep-purple lighten-5" small>
										<div class="font-size-10">0/5</div>
									</v-chip>
								</template>
							</v-slider>
						</div>
						<v-divider></v-divider>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div class="box-map">
				<GmapMap :center="{lat:10, lng:10}" :zoom="7" map-type-id="terrain" style="width: 100%; height: 100%">
				</GmapMap>
			</div>
			<div class="driver-status">
				<v-card elevation="5" width="520" class="rounded-lg pa-2">
					<div class="d-flex">
						<v-col cols="8">
							<div class="grey--text text--darken-1 font-size-11">Status</div>
							<div class="d-flex pt-1">
								<div class="red lighten-1 rounded-pill pa-2">
									<v-icon color="white">mdi-car-multiple</v-icon>
								</div>
								<div class="pl-3">
									<div class="font-size-11">Macet Dijalan Imogiri Timur KM 12</div>
									<div class="grey--text text--darken-1 font-size-10">15:24:22</div>
								</div>
							</div>
						</v-col>
						<v-divider vertical></v-divider>
						<v-col cols="4" class="text-center my-auto">
							<div class="grey--text text--darken-1 font-size-11">Tanggal</div>
							<div class="font-size-12">22 Desember 2020</div>
						</v-col>
					</div>
				</v-card>
			</div>
		</div>
		<div v-if="showedDetailExpedition">
			<DetailExpedition ref="detailExpedition" @action="hideDetailExpedition"></DetailExpedition>
		</div>
	</div>
</template>

<script>
import DetailExpedition from './DetailExpedition'

export default {
	components: {
		DetailExpedition
	},
	data () {
		return {
			taskDriver: 0,
			showedDetailExpedition: false,
		}
	},
	methods: {
		showDetailExpedition() {
			this.showedDetailExpedition = true
		},
		hideDetailExpedition() {
			this.showedDetailExpedition = false
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Lacak Ekspedisi`)
	}
};
</script>